import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import Secured from './components/Secured';
import store from './store/index';
import { setupErrorReporting } from './report';
import reportWebVitals from './reportWebVitals';

import './style/main.scss';

// Log unhandled errors to the API service.
setupErrorReporting();

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <Secured />
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
